import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import Login from './Login';
import { Box, CircularProgress } from '@mui/material';

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="100vh"
      >
        <CircularProgress size={60} />
      </Box>
    );
  }

  return user ? children : <Login />;
};

export default ProtectedRoute;